import { Link } from "react-router-dom";

const quickLinks = [
  { to: "/category/movie", label: "电影库" },
  { to: "/category/tv", label: "电视剧库" },
  { to: "/news", label: "影视资讯" },
  { to: "/search?q=推荐", label: "热门搜索" },
];

const aboutLinks = [
  { to: "/about", label: "关于我们" },
  { to: "/about", label: "免责声明" },
  { to: "/about", label: "使用说明" },
  { to: "/about", label: "联系方式" },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-primary-900 text-background-100">
      <div className="mx-auto max-w-site px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-9 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2 lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-lg font-black text-primary-950">
                91
              </span>
              <span className="font-heading text-xl font-black tracking-tight text-background-50">
                看片
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-7 text-background-300">
              91看片致力于为广大影视爱好者提供便捷的高清影视查找与资讯服务。海量电影、电视剧分类清晰、筛选高效，助你快速找到想看的内容。本站所有内容均为演示数据，播放入口不提供真实播放功能。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">
              <Link to="/" className="transition-colors hover:text-accent-300">
                快速导航
              </Link>
            </h4>
            <ul className="mt-4 space-y-3">
              {quickLinks.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className="text-sm text-background-300 transition-colors hover:text-accent-300"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">
              <Link to="/about" className="transition-colors hover:text-accent-300">
                帮助中心
              </Link>
            </h4>
            <ul className="mt-4 space-y-3">
              {aboutLinks.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className="text-sm text-background-300 transition-colors hover:text-accent-300"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-800 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2024 91看片 · 本站为演示项目，所有影视与资讯内容均为示例数据</p>
          <p className="whitespace-nowrap">
            影视资讯仅供学习交流，请支持正版
          </p>
        </div>
      </div>
    </footer>
  );
}